<template>
  <div class="cart-scroll" @scroll="getMore($event)">
    <Top />
    <div class="soso-tab">
      <div class="soso-center">
        <h3 class="soso-title">全部礼品</h3>
        
        <div class="so-box">
					<z-input  size='260' @keyup.enter="soso" v-model.trim="keyWord" placeholder="礼品编号/礼品名称"></z-input>
          <i  @click="soso" class="icons so-btn"></i>
				</div>

        <div class="soso-sort"><span :class="{'sort-on':!priceOrder}" @click="onPriceOrder(false)">默认排序</span> <span class="sort-br">|</span> <span :class="{'sort-on':priceOrder}" @click="onPriceOrder(true)">兑换分值</span><i class="icons icon-up" :class="{'icon-up-l': priceOrder && orderType,'icon-up-r': priceOrder && !orderType}"  @click="onOrderType"></i></div>
      </div>
    </div>
    
    <div class="products-list fix">
      <div class="products fix">
        <template v-if="!LoadingCart">
          <PItem v-for="n in cartList.products" :item='n' :key="n.productCode"/>
        </template>
        
        <NoList v-if="!LoadingCart && cartList.products.length == 0" title="暂无礼品可兑换" /> 
        <div class="cart-more fix" v-show="LoadingCart || LoadingScroll"><img src="../assets/car.gif" alt="正在为您加载数据...">正在为您加载数据 ...</div>

        <div class="sigma-content" v-if="!LoadingScroll && currentPage >= cartList.totalPage && cartList.products.length > 16">
          <div class="sigma-middle-line">
            <span class="sigma-line-text">我是有底线的</span>
          </div>
        </div>
      </div>
    </div>
    <FootCart />
    
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Top from "../components/top";
import ZInput from "../components/zInput";
import PItem from "../components/p-item";
import FootCart from "../components/foot-cart";
import NoList from "../components/no-list.vue";

export default {
  name: "cart",
  components: {
    Top,
    ZInput,
    PItem,
    FootCart,
    NoList
  },
  data() {
    return {
      isRouterAlive: true,
      keyWord: "",
      orderType: false,
      priceOrder: false,
      currentPage: 1
    };
  },
  computed: {
    ...mapGetters(["cartList", "LoadingCart", "LoadingScroll"])
  },
  created() {
    this.onRd();
    this.getList(this.$route.params.id);
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => (this.isRouterAlive = true));
    },
    getList(id) {
      this.$store.dispatch("ALLCARTS", id);
    },
    getMore(event) {
      // 加载
      let self = this,
        offsetHeight = event.currentTarget.offsetHeight,
        scrollHeight = event.target.scrollHeight,
        scrollTop = event.target.scrollTop,
        scrollBottom = parseInt(offsetHeight + scrollTop);

      if (scrollHeight < 600) return;
      if (scrollTop === 0) {
        // 下拉
      }
      if (
        // 上拉
        scrollBottom === scrollHeight ||
        scrollBottom === scrollHeight + 1 ||
        scrollBottom === scrollHeight + 2 ||
        scrollBottom === scrollHeight + 3 ||
        scrollBottom === scrollHeight + 4
      ) {
        self.getMoreUp();
      }
    },
    getMoreUp() {
      // 下一页
      let self = this;
      if (self.LoadingCart || self.LoadingScroll) return;
      var aPage = self.currentPage + 1;
      if (aPage > self.cartList.totalPage) return;
      this.$store.commit("CURRENT_PAGE", aPage); // 页码
      self.handleCurrentChange(aPage);
    },
    handleCurrentChange(val) {
      // 分页
      this.currentPage = val; // 当前页码
      this.$store.dispatch("MESSAGE_LIST_DPH_SCROLL"); // 滚动 加载列表数据
    },
    soso() {
      this.$store.commit("REQUEST_CONFIG_SO", this.keyWord);
      this.onRd();
      this.onMessageList();
    },
    onRd() {
      // 页码初始化
      this.currentPage = 1; // 当前页码
      this.$store.commit("CURRENT_PAGE", 1); // 页码
    },
    onMessageList() {
      // 列表
      this.$store.dispatch("PLIST");
    },
    onPriceOrder(o) {
      if (this.priceOrder == o) return;
      this.priceOrder = o;
      this.orderType = o;
      this.$store.commit("PRICE_SO", this.priceOrder);
      this.$store.commit("ORDER_SO", this.orderType);
      this.onRd();
      this.onMessageList();
    },
    onOrderType() {
      this.priceOrder = true;
      this.orderType = !this.orderType;
      this.$store.commit("PRICE_SO", this.priceOrder);
      this.$store.commit("ORDER_SO", this.orderType);
      this.onRd();
      this.onMessageList();
    }
  }
};
</script>
<style>
.soso-tab {
  width: 100%;
  height: 50px;
  margin: 0 auto;
  padding: 0;
  position: relative;
  border-bottom: 1px solid #ddd;
}
.soso-center {
  width: 1200px;
  line-height: 50px;
  margin: auto;
  text-align: left;
  overflow: hidden;
}
.soso-title {
  width: 200px;
  font-size: 18px;
  display: inline;
  color: #666;
}
.soso-sort {
  float: right;
  font-size: 14px;
  margin-right: 20px;
}
.soso-sort span {
  cursor: pointer;
}
.sort-br {
  color: #ddd;
  margin: 0 8px;
  vertical-align: 1px;
}
.sort-on {
  color: #ff0000;
}
.icon-up {
  background-position: 0px -195px;
  display: inline-block;
  width: 16px;
  height: 18px;
  vertical-align: -4px;
  margin-left: 12px;
  cursor: pointer;
}
.icon-up-l {
  background-position: -17px -195px;
}
.icon-up-r {
  background-position: -35px -195px;
}
.so-box {
  position: relative;
  margin-left: 10px;
  float: right;
}
.so-btn {
  position: absolute;
  right: 7px;
  top: 16px;
  z-index: 6;
  background-position: -19px -12px;
  display: inline-block;
  width: 17px;
  height: 20px;
  cursor: pointer;
}
.cart-scroll {
  margin: 0;
  overflow-y: auto;
  height: 100vh;
}
.products-list {
  width: 1200px;
  margin: auto;
}
.products {
  width: 1226px;
  padding-top: 20px;
}
.products .p-grid {
  position: relative;
  float: left;
  text-align: left;
  width: 230px;
  height: 360px;
  margin: 0 12px 20px 0;
  background-color: #fff;
  border: 1px solid #e7e7e7;
  -webkit-transition: border-color 0.1s ease 0s;
  -moz-transition: border-color 0.1s ease 0s;
  -o-transition: border-color 0.1s ease 0s;
  transition: border-color 0.1s ease 0s;
  box-sizing: border-box;
}

.products .p-grid:hover {
  border: 2px solid #ff7300;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.3);
  -moz-box-shadow: 0 0 4px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: 0 0 4px rgba(0, 0, 0, 0.3);
}
.products .p-grid .goods-code {
  color: #fff;
  position: absolute;
  top: 200px;
  left: 0;
  border-radius: 0;
  line-height: 30px;
  padding: 0;
  background-color: #fff;
  opacity: 0;
  z-index: 1;
  -webkit-transition: opacity 0.1s ease-in;
  transition: opacity 0.1s ease-in;
  width: 100%;
  background: #5c5c5c;
  text-align: center;
}
.products .p-grid:hover .goods-code {
  opacity: 1;
}

.products .p-grid .pic {
  height: 228px;
  border-bottom: 1px solid #eee;
}
.products .p-grid .pic a {
  display: block;
  width: 100%;
  height: 100%;
}
.products .p-grid .pic img {
  width: 228px;
  height: 228px;
  border: none;
  vertical-align: top;
}
.products .p-grid:hover .pic {
  height: 227px;
}
.products .p-grid:hover .pic img {
  width: 226px;
  height: 227px;
  border: none;
  vertical-align: top;
}
.products .p-grid .sales {
  color: #999;
  padding: 8px 8px 10px;
}
.products .p-grid:hover .sales {
  padding: 8px 7px 10px;
}
.d-ib {
  background-color: rgba(245, 245, 245, 1);
  color: #666;
  line-height: 18px;
  border-radius: 20px;
  padding: 3px 12px;
  font-size: 12px;
  margin-right: 10px;
}
.is-err {
  color: #ff0000;
  background-color: #ffe5e5;
}
.products .p-grid .sales .sales-volume {
  margin-left: 10px;
  line-height: 18px;
  border-radius: 20px;
  padding: 3px 12px;
  font-size: 12px;
  color: #ff0000;
  background-color: #ffe5e5;
}
.gift-btn {
  float: right;
}
.products .p-grid .p-name {
  height: 42px;
  padding: 7px 7px 0 7px;
  overflow: hidden;
  text-align: left;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.products .p-grid .p-name a {
  color: #666;
}
.products .p-grid:hover .p-name {
  padding: 7px 6px 0 6px;
}
.products .p-grid .b-price {
  padding: 0 8px 0 6px;
  color: #ff7300;
  font-size: 14px;
  line-height: 30px;
}
.products .p-grid:hover .b-price {
  padding: 0 7px 0 5px;
}
.products .p-grid .b-price span img {
  width: 20px;
  height: 20px;
  vertical-align: -5px;
  margin-right: 5px;
}

.cart-more {
  margin: 20px 0 50px;
  color: #999;
  width: 1200px;
  float: left;
}
.cart-more img {
  width: 100px;
  margin-right: 15px;
  vertical-align: -20px;
}
.sigma-content {
  width: 1200px;
  margin: 20px 0 50px;
  text-align: center;
  background-color: #fff;
  float: left;
}
.sigma-middle-line:before {
  content: "";
  display: block;
  height: 1px;
  width: 100%;
  background-color: #eee;
  position: relative;
  top: 10px;
  left: 0;
}
.sigma-line-text {
  display: inline-block;
  background: #fff;
  padding: 0 18px 0 18px;
  position: relative;
  font-size: 14px;
  font-weight: 500;
  color: #999;
}
</style>